module.exports = function (element, message) {
    /**
     * Set cookie with consent tracking
     * @param {string} name - cookie name
     * @param {string} value - cookie value
     * @param {number} days - days to expire
     */
    function setCookie(name, value, days) {
        var expires = "";
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + value + expires + "; path=/";
    }

    /**
     * Get cookie value
     * @param {string} name - cookie name
     * @returns {string|null} cookie value or null if not found
     */
    function getCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) === ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }

    /**
     * Close cookie banner
     */
    function closeCookieBanner() {
        $("#cookieBanner").slideUp();
    }
    
    /**
     * Accept cookies
     */
    function acceptCookies() {
        setCookie('consentTracking', 'true', 365); // Cookie válida por 1 año
        
        closeCookieBanner();
    }

    /**
      * Show only if not accepted before
    */
    if (getCookie('consentTracking') !== 'true') {
        $("#cookieBanner").slideDown();
    }

    $("#cookieBanner").on('click', '.accept-cookies', acceptCookies);
    $("#cookieBanner .btn-close").on('click', closeCookieBanner);
};